module.exports = __webpack_public_path__ + "static/media/ore2.png.f2b227c1.jpg";